angular.module('gym.waivers').controller('WaiverResendConsentRequestModalCtrl', ["$scope", "$modalInstance", "waiver", "waiverReview", "gym", function($scope, $modalInstance, waiver, waiverReview, gym) {
  var ref;
  $scope.gym = gym;
  $scope.primaryContact = waiver.signed_waiver_contacts_attributes.find(function(c) {
    return c.primary;
  });
  $scope.params = {
    message: ((ref = waiverReview.consent_request_details) != null ? ref.email_message_from_gym : void 0) || waiverReview.default_email_message_from_gym
  };
  $scope.submit = function() {
    var data;
    $scope.errors = {};
    if (!$scope.params.message) {
      $scope.errors = {
        message: 'This field is required'
      };
      return;
    }
    data = {
      message: $scope.params.message,
      consentRequest: waiverReview.consent_request_details
    };
    return $modalInstance.close(data);
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
